<template>
  <div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_on_details_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Edit locations Info Form"
      id="owner_view_locations_edit_form"
    ></CardedSectionHeader>
    <CardedForm
      ref="locations_form_ref"
      id="locations_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <TextArea
        v-model="form.manual_directions"
        :validation_rules="form_validations.manual_directions"
        label="Directions to business (e.g How can clients find your business)"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextArea>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.district_id"
            :options="districts"
            :small_chips="false"
            :validation_rules="form_validations.district_id"
            label="District"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.city_id"
            :options="cities"
            :small_chips="false"
            :validation_rules="form_validations.city_id"
            label="City"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.ward_id"
            :options="wards"
            :small_chips="false"
            :validation_rules="form_validations.ward_id"
            label="Ward"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.street_id"
            :options="streets"
            :small_chips="false"
            :validation_rules="form_validations.street_id"
            label="Street"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>
      <TextField
        v-model="form.physical_address"
        :validation_rules="form_validations.physical_address"
        label="Enter Physical Address: (e.g plot 22211 phase 4, Gaborone)"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.lat"
            :validation_rules="form_validations.lat"
            label="Latitude Google Map Cordinate"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.lng"
            :validation_rules="form_validations.lng"
            label="Longitude Google Map Cordinate"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
      </v-row>
      <small>
        <b>
            Click on the map, where your business is located to get the cordinates, 
            you can drag and expand the map untill you find your businesses location.
        </b>
      </small>
      <GeoMap
        :business="business"
        :is_owner="is_owner"
        :is_editing="true"
        @on-set-location="on_set_location"
      ></GeoMap>
      <br />
    </CardedForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import TextArea from "../../../components/TextArea";
import TextField from "../../../components/TextField";
import SelectField from "../../../components/SelectField";
import GeoMap from "../../../components/GeoMap";
export default {
  name: "OwnerBusinessesManageLocations",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedForm,
    TextArea,
    SelectField,
    TextField,
    GeoMap,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      business: Utils.get_default_business(),
      is_owner: false,
      _user: null,
      errors: [],
      message: "",
      form: {
        district_id: 0,
        city_id: 0,
        ward_id: 0,
        street_id: 0,
        manual_directions: "",
        physical_address: "",
        lat: 0,
        lng: 0,
      },
      form_validations: {
        district_id: [
          Utils.validate.is_required(
            "Please select the district where your business is located"
          ),
        ],
        city_id: [
            
        ],
        ward_id: [],
        street_id: [],
        manual_directions: [
          Utils.validate.max_length(
            200,
            "Directions to your business should be less than 200 characters"
          ),
        ],
        physical_address: [
          Utils.validate.max_length(
            150,
            "Your business physicall address should be less than 150 characters"
          ),
        ],
        lat: [Utils.validate.number_value("Latitude has to be a number value")],
        lng: [
          Utils.validate.number_value("Longitude has to be a number value"),
        ],
      },
      districts: [],
    };
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 456);
      this.form.district_id = 0;
      this.form.city_id = 0;
      this.form.ward_id = 0;
      this.form.street_id = 0;
      this.form.manual_directions = "";
      this.form.physical_address = "";
      this.form.lat = 0;
      this.form.lng = 0;

      this.errors = [];
      this.message = "";
    },
    init_form() {
      this.form.district_id = 0;
      this.form.city_id = 0;
      this.form.ward_id = 0;
      this.form.street_id = 0;
      this.form.manual_directions = "";
      this.form.physical_address = "";
      this.form.lat = 0;
      this.form.lng = 0;
      this.errors = [];
      this.message = "";
      if (this.business && parseInt(this.business.id) > 0) {
        this.form.district_id = parseInt(this.business.district_id);
        this.form.city_id = parseInt(this.business.city_id);
        this.form.ward_id = parseInt(this.business.ward_id);
        this.form.street_id = parseInt(this.business.street_id);
        this.form.manual_directions = this.business.manual_directions;
        this.form.physical_address = this.business.physical_address;
        this.form.lat = parseFloat(this.business.lat);
        this.form.lat = parseFloat(this.business.lat);
      }
    },
    get_register_business_dependencies() {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_register_business_dependencies(
        {
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.my_companies = [
            {
              id: 0,
              name: "Self",
            },
          ].concat(res.businesses);
          this.districts = res.districts;
          this.init_form();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.locations_form_ref.show_error_dialog();
        }
      );
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            this.get_register_business_dependencies();
            //nyd
            //if they are not the owner
            //show them a message of not authorised
            //then redirect them to the login screen
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.locations_form_ref.show_error_dialog();
        }
      );
    },
    submit() {
        this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Businesses.update_business_location({
          ...this.form,
          id: this.business_id,
          user_id: this.user.id,
      },
      (res) => {
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/> Your business location information has been updated successfully";
          this.$refs.locations_form_ref.show_message_dialog();
      }, (errors) => {
          this.errors = errors;
          this.$refs.locations_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
      });
    },
    on_hide_message() {
        this.load_business(this.business_id);
    },
    on_set_location(lat_lng) {
      this.form.lat = lat_lng.lat;
      this.form.lng = lat_lng.lng;
    },
  },
  computed: {
    cities() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          temp = district.cities;
          break;
        }
      }
      return temp;
    },
    wards() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          temp = district.wards;
          break;
        }
      }
      return temp;
    },
    streets() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        var found = false;
        if (parseInt(district["id"]) == parseInt(this.form.district_id)) {
          var wards = district.wards;
          for (var index2 = 0; index2 < wards.length; index2++) {
            var ward = wards[index2];
            if (parseInt(ward.id) == parseInt(this.form.ward_id)) {
              temp = ward.streets;
              found = true;
              break;
            }
          }
        }
        if (found == true) {
          break;
        }
      }
      return temp;
    },
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Business Manage Locations Info",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses/",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/businesses/list/view/" + this.business_id,
        },
        {
          text: "Locations",
          disabled: true,
          href:
            "/owner/businesses/list/view/" +
            this.business_id +
            "/locations/manage",
        },
      ],
      navbar_cols: 3,
    });
    this.init_form();
    this.load_business(this.business_id);

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_view_locations_edit_form", options);
  },
};
</script>